/**
 * @generated SignedSource<<ee7b53a8ceb7854f5f93049bdfb2663f>>
 * @relayHash 0642c16ef921ddeb23d0f5a9e9f83d68
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID 183d70a02814b3429a97f14e6184a1ee5336be0a7ed9d99dcf55630dc28d2635

import type { ConcreteRequest } from 'relay-runtime';
import type { FragmentRefs } from "relay-runtime";
export type ServicesAndSkillsRowLiveRoutingTableQuery$variables = {
  cloudId: string;
  isJsmRoutingFixesForGaEnabled: boolean;
  projectKey: string;
};
export type ServicesAndSkillsRowLiveRoutingTableQuery$data = {
  readonly " $fragmentSpreads": FragmentRefs<"ServicesAndSkillsRow">;
};
export type ServicesAndSkillsRowLiveRoutingTableQuery = {
  response: ServicesAndSkillsRowLiveRoutingTableQuery$data;
  variables: ServicesAndSkillsRowLiveRoutingTableQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "cloudId"
},
v1 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "isJsmRoutingFixesForGaEnabled"
},
v2 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "projectKey"
},
v3 = {
  "kind": "Variable",
  "name": "cloudId",
  "variableName": "cloudId"
},
v4 = {
  "kind": "Variable",
  "name": "projectKey",
  "variableName": "projectKey"
},
v5 = [
  (v3/*: any*/),
  (v4/*: any*/)
],
v6 = {
  "kind": "ScalarField",
  "name": "id"
};
return {
  "fragment": {
    "argumentDefinitions": [
      (v0/*: any*/),
      (v1/*: any*/),
      (v2/*: any*/)
    ],
    "kind": "Fragment",
    "name": "ServicesAndSkillsRowLiveRoutingTableQuery",
    "selections": [
      {
        "args": [
          (v3/*: any*/),
          {
            "kind": "Variable",
            "name": "isJsmRoutingFixesForGaEnabled",
            "variableName": "isJsmRoutingFixesForGaEnabled"
          },
          (v4/*: any*/)
        ],
        "kind": "FragmentSpread",
        "name": "ServicesAndSkillsRow"
      }
    ],
    "type": "Query"
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [
      (v0/*: any*/),
      (v2/*: any*/),
      (v1/*: any*/)
    ],
    "kind": "Operation",
    "name": "ServicesAndSkillsRowLiveRoutingTableQuery",
    "selections": [
      {
        "condition": "isJsmRoutingFixesForGaEnabled",
        "kind": "Condition",
        "passingValue": true,
        "selections": [
          {
            "args": [
              (v3/*: any*/)
            ],
            "concreteType": "JiraRovoEnablementStatus",
            "kind": "LinkedField",
            "name": "jira_rovoEnablementStatus",
            "plural": false,
            "selections": [
              {
                "kind": "ScalarField",
                "name": "isRovoEntitlementEnabledForTenant"
              },
              {
                "kind": "ScalarField",
                "name": "rovoAiFeaturesEnabledJiraProducts"
              }
            ]
          }
        ]
      },
      {
        "args": (v5/*: any*/),
        "concreteType": "AgentWorkspaceSmartRoutingConfig",
        "kind": "LinkedField",
        "name": "agentWorkspace_routingConfig",
        "plural": false,
        "selections": [
          {
            "kind": "ScalarField",
            "name": "enabled"
          },
          {
            "kind": "ScalarField",
            "name": "serviceFieldId"
          },
          {
            "kind": "ScalarField",
            "name": "serviceFieldName"
          },
          {
            "kind": "ScalarField",
            "name": "serviceFieldType"
          }
        ]
      },
      {
        "args": (v5/*: any*/),
        "concreteType": "AgentWorkspaceLiveRoutingTable",
        "kind": "LinkedField",
        "name": "agentWorkspace_liveRoutingTable",
        "plural": false,
        "selections": [
          {
            "concreteType": "AgentWorkspaceRoutingTableEntry",
            "kind": "LinkedField",
            "name": "entries",
            "plural": true,
            "selections": [
              {
                "kind": "ScalarField",
                "name": "serviceId"
              },
              {
                "kind": "ScalarField",
                "name": "serviceName"
              },
              {
                "concreteType": "TeamV2",
                "kind": "LinkedField",
                "name": "team",
                "plural": false,
                "selections": [
                  {
                    "kind": "ScalarField",
                    "name": "displayName"
                  },
                  {
                    "kind": "ScalarField",
                    "name": "smallAvatarImageUrl"
                  },
                  (v6/*: any*/)
                ]
              },
              {
                "concreteType": "AgentWorkspaceSkill",
                "kind": "LinkedField",
                "name": "skills",
                "plural": true,
                "selections": [
                  {
                    "kind": "ScalarField",
                    "name": "name"
                  },
                  (v6/*: any*/)
                ]
              },
              {
                "kind": "ScalarField",
                "name": "description"
              }
            ]
          }
        ]
      }
    ]
  },
  "params": {
    "id": "183d70a02814b3429a97f14e6184a1ee5336be0a7ed9d99dcf55630dc28d2635",
    "metadata": {},
    "name": "ServicesAndSkillsRowLiveRoutingTableQuery",
    "operationKind": "query",
    "text": null
  }
};
})();

(node as any).hash = "0e56b5b7736fdc215186e189ff91e22e";

export default node;
